/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {Course} from "../model/course";
import {CourseMembership} from "../model/course-membership";
import {LmsEntityStatus} from "../model/lms-entity-status";
import {User} from "../model/user";

@Injectable({
    providedIn: "root",
})
export class SimLmsService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getCourseById(courseId: string) {
        return super.get<Course>(`/api/Lms/GetCourseById`, {courseId: courseId});
    }

    public getCourses(offset: number, limit: number, name: string) {
        return super.get<Course[]>(`/api/Lms/GetCourses`, {offset: offset, limit: limit, name: name});
    }

    public getCoursesMembership(offset: number, limit: number, courseId: string) {
        return super.get<CourseMembership[]>(`/api/Lms/GetCoursesMembership`, {offset: offset, limit: limit, courseId: courseId});
    }

    public getStatus(id: string) {
        return super.get<LmsEntityStatus>(`/api/Lms/GetStatus`, {id: id});
    }

    public getUserById(userId: string) {
        return super.get<User>(`/api/Lms/GetUserById`, {userId: userId});
    }

    public getUsers(offset: number, limit: number, username: string, lastName: string, studentId: string, email: string) {
        return super.get<User[]>(`/api/Lms/GetUsers`, {offset: offset, limit: limit, username: username, lastName: lastName, studentId: studentId, email: email});
    }

    public publishEntity(id: string, publish: boolean) {
        return super.get<void>(`/api/Lms/PublishEntity`, {id: id, publish: publish});
    }

    public uploadEntity(id: string) {
        return super.get<void>(`/api/Lms/UploadEntity`, {id: id});
    }
}